import {Button, DialogContent, DialogContentText, Stack} from '@mui/material';
import AutoHeight from 'embla-carousel-auto-height';
import React from 'react';

import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import Image from 'presentation/assets/images/general-review.svg';
import {Carousel} from 'presentation/components';
import {useCarrouselIndexStore} from 'presentation/components/Carrousel/store';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {translations} from 'presentation/translations-new';
import {useRatingModal} from '../../hooks/useRatingModals';
import {ImageContainer, StyledCarouselContainer, StyledDialog, StyledDialogHeader} from './styles';
import {SelectEvaluationsProps} from './types';

const {rateYourAttendance, dontWantRate, rateThisAttendance, rateYourAttendances} =
	translations['pt-br'].privateFlow.fiveStarsRating;

export function SelectEvaluations({ratings}: SelectEvaluationsProps) {
	const carrouselIndex = useCarrouselIndexStore(state => state.carrouselIndex);

	const {handleGoToEvaluationPage, handleOpenRefuseToEvaluateModal} = useRatingModal();

	const headerTitle = ratings.count > 1 ? rateYourAttendances : rateYourAttendance;

	return (
		<StyledDialog open={true} data-tag-id={FiveStarsEnum.VISUALIZOU_MODAL_AVALIACOES}>
			<StyledDialogHeader>{headerTitle}</StyledDialogHeader>
			<StyledCarouselContainer>
				<Carousel
					prevDataTagId={FiveStarsEnum.CLICK_ATENDIMENTO_ANTERIOR}
					nextDataTagId={FiveStarsEnum.CLICK_PROXIMO_ATENDIMENTO}
					textDataTagId={FiveStarsEnum.NUMERO_DE_AVALIACOES}
					controlledIndex
					numbersText="avaliações"
					plugins={[AutoHeight()]}
					options={{loop: true}}
					type={CarrouselTypeEnum.NUMBERS}
					isFullscreen
					slides={ratings.items.map(rating => (
						<DialogContent sx={{p: 2}} key={rating.keys.cdatendimento}>
							<ImageContainer>
								<img
									src={Image}
									alt="Uma pessoa com uma mochila nas costas e uma lupa na mão, está olhando para uma bifurcação no caminho, sem saber qual direção seguir."
									width={140}
									height={140}
								/>
							</ImageContainer>
							<DialogContentText color="text.primary" textAlign="center" mt={2}>
								{rating.values.info.info[0]}
							</DialogContentText>
						</DialogContent>
					))}
				/>
			</StyledCarouselContainer>
			<Stack p={2} gap={1}>
				<Button
					fullWidth
					size="large"
					data-tag-id={FiveStarsEnum.CLICK_AVALIAR_ATENDIMENTO}
					onClick={() =>
						handleGoToEvaluationPage({
							cdAtendimento: ratings.items[carrouselIndex].keys.cdatendimento,
							tipo: ratings.items[carrouselIndex].keys.tipo,
						})
					}>
					{rateThisAttendance}
				</Button>
				<Button
					fullWidth
					size="large"
					variant="outlined"
					data-tag-id={FiveStarsEnum.CLICK_NAO_QUERO_AVALIAR}
					onClick={() =>
						handleOpenRefuseToEvaluateModal({
							cdAtendimento: ratings.items[carrouselIndex].keys.cdatendimento,
							tipo: ratings.items[carrouselIndex].keys.tipo,
						})
					}>
					{dontWantRate}
				</Button>
			</Stack>
		</StyledDialog>
	);
}
